import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ComponentWrapper } from '@trello/component-wrapper';
import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { CardDateRangePickerProps } from './CardDateRangePicker';

export const LazyCardDateRangePicker: FunctionComponent<
  CardDateRangePickerProps
> = ({
  due,
  start,
  disableStartDate,
  dueReminder,
  idCard,
  idBoard,
  idOrg,
  hidePopover,
  initialChoice,
}) => {
  const CardDateRangePicker = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "card-date-range-picker" */ './CardDateRangePicker'
      ),
    { namedImport: 'CardDateRangePicker' },
  );
  return (
    <ComponentWrapper key="date-range-picker">
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <CardDateRangePicker
            due={due}
            start={start}
            disableStartDate={disableStartDate}
            dueReminder={dueReminder}
            idCard={idCard}
            idBoard={idBoard}
            idOrg={idOrg}
            hidePopover={hidePopover}
            initialChoice={initialChoice}
          />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ComponentWrapper>
  );
};
